import React from "react";
import { Line } from "react-chartjs-2";
import { ChartOptions } from "chart.js";
import { KpiClientAssistancesHistoryDashboardResponseDTO } from "../../models/Kpi/KpiClientAssistancesHistoryDashboardResponseDTO";

interface AssistanceHistoryPerClientProps {
    data?: KpiClientAssistancesHistoryDashboardResponseDTO[];
}

const KpiClientAssistancesHistoryDashboard: React.FC<AssistanceHistoryPerClientProps> = ({ data }) => {
    const chartData = {
        labels: (data || []).map(d => d.week),
        datasets: [
            {
                label: "Assistências",
                data: (data || []).map(d => d.assistanceCount),
                borderColor: "rgba(0, 123, 255, 1)",
                backgroundColor: "rgba(0, 123, 255, 0.2)",
                fill: true,
                tension: 0.3,
            },
        ],
    };

    const options: ChartOptions<"line"> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: "Semanas",
                },
            },
            y: {
                title: {
                    display: true,
                    text: "Assistências",
                },
                beginAtZero: true,
            },
        },
    };

    return (
        <div>
            <div className="w-full max-w-lg h-80 p-4 bg-white shadow-md rounded-2xl mx-auto">
                <h2 className="text-lg font-semibold text-center">Histórico de Assistências</h2>
                <div className="h-64">
                    <Line data={chartData} options={options} />
                </div>
            </div>
        </div>
    );
};

export default KpiClientAssistancesHistoryDashboard;